import { Spark } from "@scoach/ui/icons";

import { useSuggestedQuestions } from "../useSuggestedQuestions.ts";

/**
 * Suggests adding questions the rep asks repeatedly across recent meetings to
 * their saved custom questions. Rendered in Settings, the summary page, and the
 * dashboard — all share one data source (useSuggestedQuestions). Renders nothing
 * when there are no suggestions.
 */
export function SuggestedQuestionsBanner({
  compact,
  onAdded,
}: { compact?: boolean; onAdded?: (question: string) => void } = {}) {
  const { suggestions, add, dismiss } = useSuggestedQuestions();
  if (suggestions.length === 0) return null;

  const handleAdd = async (question: string) => {
    await add(question);
    onAdded?.(question);
  };

  return (
    <div className="prior-banner" style={{ marginBottom: 16 }}>
      <div className="prior-icon">
        <Spark size={16} />
      </div>
      <div style={{ flex: 1 }}>
        <div className="prior-title">You keep asking these — add them to your questions?</div>
        {!compact && (
          <div className="prior-sub">
            SellSynq noticed these come up across your recent meetings. Add them so they're tracked
            live in every call.
          </div>
        )}
        <div style={{ display: "flex", flexDirection: "column", gap: 8, marginTop: 10 }}>
          {suggestions.map((s) => (
            <div
              key={s.question}
              style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}
            >
              <span style={{ flex: 1, fontSize: 13 }}>
                {s.question}{" "}
                <span style={{ color: "var(--text-4)" }}>· asked in {s.count} meetings</span>
              </span>
              <button type="button" className="pill-btn xs" onClick={() => void handleAdd(s.question)}>
                Add
              </button>
              <button
                type="button"
                className="ghost-btn xs"
                onClick={() => void dismiss(s.question)}
              >
                Dismiss
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
